import { useMemo } from 'react'

import { useGetAccountQuery } from '../store/accountUserSettings/accountUserSettings'
import { selectAccountId } from '../store/auth/authSlice'
import { useAppSelector } from '../store/hooks'

import { useZocksQuota } from '../components/ScopedBlock/hooks'

import { stripToText } from './util'

export const useEffectiveConfig = () => {
  const accountId = useAppSelector(selectAccountId)
  const { data: accountResponse, isFetching: accountIsFetching } = useGetAccountQuery({ accountId })

  const { hasQuota } = useZocksQuota()

  const complianceMessageEnabled = hasQuota('ai.complianceMessage.value')

  const effectiveConfig = accountResponse?.data?.effectiveConfig
  const complianceConfig = effectiveConfig?.complianceConfig

  const pdfComplianceMessage = useMemo(() => {
    const { enabled: pdfComplianceMessageEnabled, message } = complianceConfig?.pdfComplianceMessage ?? {}

    if (!complianceMessageEnabled || !pdfComplianceMessageEnabled || !message) {
      return null
    }

    return stripToText(message)
  }, [complianceConfig, complianceMessageEnabled])

  const emailComplianceMessage = useMemo(() => {
    const { enabled: emailComplianceMessageEnabled, message } = complianceConfig?.emailComplianceMessage ?? {}

    if (!complianceMessageEnabled || !emailComplianceMessageEnabled || !message) {
      return null
    }

    return stripToText(message)
  }, [complianceConfig, complianceMessageEnabled])

  const copyComplianceMessage = useMemo(() => {
    const { enabled: copyComplianceMessageEnabled, message } = complianceConfig?.copyComplianceMessage ?? {}

    if (!complianceMessageEnabled || !copyComplianceMessageEnabled || !message) {
      return null
    }

    return stripToText(message)
  }, [complianceConfig, complianceMessageEnabled])

  return { effectiveConfig, emailComplianceMessage, pdfComplianceMessage, copyComplianceMessage, accountIsFetching }
}
